import { cn } from '@/utils/cn';

const Container = ({ className, ...rest }: ContainerProps) => {
  return (
    <div
      className={cn('w-full mx-auto max-w-container px-container-x', className)}
      {...rest}
    />
  );
};

export default Container;

type ContainerProps = React.HTMLAttributes<HTMLDivElement>;
